const guiColors = {
    'motion-primary': '#49214A',
    'motion-primary-transparent': '#49214Ae6',
    'motion-tertiary': '#3a1a3b',

    'looks-secondary': '#6b3d6c',
    'looks-tertiary': 'hsla(300, 29%, 23%, 1)',
    'looks-transparent': '#6b3d6c59',
    'looks-light-transparent': '#6b3d6c26',
    'looks-secondary-dark': 'hsla(300, 29%, 33%, 1)',

    'extensions-primary': 'hsla(300, 38%, 21%, 1)',
    'extensions-tertiary': 'hsla(300, 38%, 13%, 1)',
    'extensions-transparent': 'hsla(300, 38%, 21%, 0.35)',
    'extensions-light': 'hsla(300, 29%, 33%, 1)',

    'drop-highlight': '#8a4d8b'
};

const blockColors = {
    checkboxActiveBackground: '#49214A',
    checkboxActiveBorder: '#3a1a3b'
};

export {
    guiColors,
    blockColors
};
